import type { ScreenSchema } from './types';

/**
 * Schema for voicemail and guided-voicemail templates.
 *
 * Both templates present a native <audio> element that plays a pre-recorded
 * voicemail message. This recording is a self-contained media asset — it is NOT
 * derived from YAML text and is therefore outside the schema system.
 *
 * Audible content:
 *   - `intro` — standard uc-content block (heading → text → instructions),
 *               narrated when the section first becomes active to introduce the
 *               voicemail exercise before the learner presses play.
 *
 * Note: screen-voicemail.vue calls stop() from audio.ts when the voicemail
 * <audio> element begins playing, which correctly interrupts any ongoing
 * schema-driven narration.
 */
const voicemailSchema: ScreenSchema = {
  template: ['voicemail', 'guided-voicemail'],
  slots: {
    intro: {
      parts: [
        { field: 'heading', fallback: ['subheading', 'title'] },
        { field: 'text' },
        { field: 'instructions' }
      ]
    }
  }
};

export default voicemailSchema;
